import assign = require('object-assign');

function hashCode(str) { // java String#hashCode
    var hash = 0;
    for (var i = 0; i < str.length; i++) {
       hash = str.charCodeAt(i) + ((hash << 5) - hash);
    }
    return hash;
} 

function intToRGB(i){
    var c = (i & 0x00FFFFFF)
        .toString(16)
        .toUpperCase();

    return "00000".substring(0, 6 - c.length) + c;
}

export default class AvailableWidget {
    public maxPossibleUsage = 99;
    public color;

    constructor(public id: string, public type: string, public displayName: string, private defaultSettings?: Object) { 
        this.color = '#' + intToRGB(hashCode(type));
    }

    getDefaultSettings() {
        return assign({}, this.defaultSettings);
    }
}


// WEBPACK FOOTER //
// ./src/store/models/AvailableWidget.ts